import { Edit, Form, Image, Input, Select, useForm } from '@pankod/refine-antd';
import { IResourceComponentsProps, useShow } from '@pankod/refine-core';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { IAds } from 'types/ads.interface';

export const AdsEdit: React.FC<IResourceComponentsProps> = () => {
    const { formProps, saveButtonProps, formLoading } = useForm<IAds>();

    const { queryResult } = useShow<IAds>();
    const { data, isLoading } = queryResult;
    const record: any = data?.data;

    const option = [
        {
            label: 'Pending',
            value: 'Pending',
        },
        {
            label: 'Approve',
            value: 'Approved',
        },
        {
            label: 'Reject',
            value: 'Rejected',
        },
    ];

    return (
        <Edit saveButtonProps={saveButtonProps} isLoading={isLoading || formLoading}>
            <Form {...formProps} layout='vertical'>
                <Form.Item label='Link' name='link' initialValue={record?.data.link}>
                    <Input disabled defaultValue={record?.data.link} />
                </Form.Item>
                <Form.Item label='Image' name='adsImageUrl' initialValue={record?.data.adsImageUrl}>
                    <Image src={record?.data.adsImageUrl} />
                </Form.Item>
                <Form.Item
                    label='Status'
                    name='status'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select style={{ width: '200px' }} defaultValue={record?.data?.status} options={[...option]} />
                </Form.Item>
            </Form>
        </Edit>
    );
};
